module.exports = __webpack_public_path__ + "img/logo.cfda08c3.png";